import { styled } from "@linaria/react";
import React from "react";

interface card {
  padding?: string;
  mobilePadding?: string;
  marginTop?: string;
  backgroundColor?: string;
  width?: string;
  flexDirection?: string;
  opacityValue?: string;
}

const Card = styled.div<card>`
  background-color: ${(props) => props.backgroundColor || "white"};
  margin-top: ${(props) => props.marginTop || "30px"};
  max-width: ${(props) => props.width || "100%"};
  padding: ${(prop) => prop.padding || "24px"};
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "column"};
  align-items: center;
  border-radius: 24px;
  opacity: ${(props) => props.opacityValue || 1};
  @media screen and (max-width: 768px) {
    padding: ${(prop) => prop.mobilePadding || "24px 16px"};
  }
`;

interface ICardComponent {
  padding?: string;
  mobilePadding?: string;
  children: any;
  flexDirection?: string;
  backgroundColor?: string;
  marginTop?: string;
  width?: string;
  className?: any;
  opacityValue?: string;
}

function CardComponent(prop: ICardComponent) {
  return <Card {...prop}>{prop.children}</Card>;
}

export default CardComponent;
